import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import {
    BenefBenefMatriculeModel,
    MutationGetListeBeneficiairesContactesPublipostageArgs
} from 'src/graphql/generated-types';
import gql from 'graphql-tag';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { KalTableHeader } from 'src/app/_shared/modules/kal-table/classes/kal-table-header';
import { KalTableGenericDatasource } from 'src/app/_shared/modules/kal-table/classes/kal-table-generic-datasource';

export interface SharedContactedBeneficiariesDialogData {
    sendHistoryId: number;
}

@Component({
    selector: 'app-shared-contacted-beneficiaries-dialog',
    templateUrl: './shared-contacted-beneficiaries-dialog.component.html',
    styleUrls: ['./shared-contacted-beneficiaries-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedContactedBeneficiariesDialogComponent extends BaseComponent implements OnInit {

    tableDataSource: KalTableGenericDatasource<BenefBenefMatriculeModel>;

    columns: KalTableHeader<BenefBenefMatriculeModel>[] = [
        {code: 'Matricule', label: 'Matricule'},
        {code: 'Nom', label: 'Nom'},
        {code: 'Prenom', label: 'Prenom'},
    ];

    constructor(private dialogRef: KalDialogRef<SharedContactedBeneficiariesDialogComponent>,
                private graphqlService: GraphqlService,
                protected cdr: ChangeDetectorRef,
                @Inject(KAL_DIALOG_DATA) public data: SharedContactedBeneficiariesDialogData) {
        super(cdr);
    }

    close() {
        this.dialogRef.close();
    }

    export() {
        this.tableDataSource.exportAsCSV(this.columns, 'beneficiaires_contactes');
        this.close();
    }

    private getSendHistoryDetail(): void {
        this.loading = true;

        this.watch$ = this.graphqlService.mutateOne<'GetListeBeneficiairesContactesPublipostage', MutationGetListeBeneficiairesContactesPublipostageArgs>({
            mutation: gql`
                mutation GetListeBeneficiairesContactesPublipostage($contexte: ContextInfosInput, $idHistoriqueCourrier: Float) {
                    GetListeBeneficiairesContactesPublipostage(contexte: $contexte, idHistoriqueCourrier: $idHistoriqueCourrier) {
                        BenefBenefMatriculeModel {
                            Id
                            Prenom
                            Nom
                            Matricule
                        }
                    }
                }
            `,
            variables: {
                idHistoriqueCourrier: this.data.sendHistoryId
            }
        })
        .pipe(
            tap((GetListeBeneficiairesContactesPublipostage) => {
                this.tableDataSource.setRows(GetListeBeneficiairesContactesPublipostage?.BenefBenefMatriculeModel || []);
                this.loading = false;
            }),
            catchError(err => {
                this.loading = false;
                return throwError(err);
            }),
        );
    }

    ngOnInit(): void {
        this.tableDataSource = new KalTableGenericDatasource<BenefBenefMatriculeModel>();

        this.getSendHistoryDetail();
    }

}
